import { useLocation } from 'react-router-dom';
import { MenuItems } from 'context';

/**
 * Какой пункт меню подсветить.
 *
 * 🔴 Сравниваем ПЕРВЫЙ СЕГМЕНТ адреса, а не весь путь. Раньше здесь стояло
 * `pathname.replace('/', '')`, то есть точное совпадение со всей строкой, — и
 * любая подстраница гасила подсветку: на `/career/learning` и
 * `/career/learning/:id` меню уже сейчас тухнет, хотя человек никуда из
 * раздела не уходил. Из-за этого же панели «Моего роста» пришлось разводить
 * через `?tab=` вместо нормальных адресов.
 *
 * Значение `MenuItems` по-прежнему обязано совпадать с первым сегментом URL —
 * это и есть контракт, просто теперь он соблюдается на всю глубину.
 */
export const useActiveMenu = (): MenuItems | undefined => {
  const { pathname } = useLocation();

  const [firstSegment] = pathname.split('/').filter(Boolean);

  return Object.values(MenuItems).find((item) => item === firstSegment);
};
